










































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetTerms } from "@/request/projects";
import Jiatingzhuzhi from "./rkxxx-contents/jiatingzhuzhi.vue";
import Wenjian from "./rkxxx-contents/wenjian.vue";
@Component({
  components: {
    Jiatingzhuzhi,
    Wenjian
  },
})
export default class ZbsjkRkxxxTransfer extends Vue {
  @Prop()
  private content: any;
  private resultOptions: any[] = [];
  /**
   * @description content双向绑定
   */
  private contentChange() {
    this.$emit("update:content", this.content);
  }
  @Watch("content.type", { immediate: true })
  private contentTypeChange(type) {
    if (this.content["type"] === "多选") {
      this.$nextTick().then(() => {
        if (!Array.isArray(this.content.value)) {
          this.content.value = [];
        }
      });
    }
    if (this.content["type"] === "搜索多选") {
      this.$nextTick().then(() => {
        this.resultOptions = this.content.value;
      });
    }
  }
  /**
   * @description 搜索
   */
  private fetchOptions(ev) {
    let searchType: string = this.content["search"];
    if (searchType === "伴随症状") {
      searchType = "中医症状";
    }
    const params: any = {
      params: {
        type: searchType,
        search: ev,
      },
    };
    GetTerms(this, params).then((data: any) => {
      this.resultOptions = data.concat(this.content.value);
    });
  }
}
